// extracted by mini-css-extract-plugin
export default {"reviews":"ax","yotpo":"bx","wrapper":"cx","review_list":"ex","carousel":"fx","swiper-slide":"gx","review":"hx","title":"ix","verified":"jx"};
    if(module.hot) {
      // 1713996746786
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  